import { useFela } from 'react-fela';
import Spin from 'antd/lib/spin';
import { upperFirst as _upperFirst } from 'lodash';

import config from 'config/index';

import rule from './Loader.rule';

const Loader = () => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <Spin>
                <img alt={_upperFirst(config.app.name)} src={config.app.brand.images.logo} />
            </Spin>
        </div>
    );
};

export default Loader;
